module.exports = __webpack_public_path__ + "img/UX.8f7e5f6f.jpg";